import React from "react";
import ListPropertyCTA from "./components/ListPropertyCTA";

const ListPropertySection = () => {
  return (
    <section className="mt-16">
      <ListPropertyCTA />
    </section>
  );
};

export default ListPropertySection;
